import { NgModule, ModuleWithProviders, SkipSelf, Optional, NgModuleRef, InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ApiConfigManager, ApiConfigOptions, ModuleSourceInfo } from '@sg/api/base-api-lib';
import { LogsApiClient, UsersApiClient, SettingsApiClient } from './services';
import { IdentityServerApiConfig } from './api-config';

declare module '../../../base-api-lib/src/lib/api-config-manager' {
  interface ApiConfigOptionsStore {
    identityServerApiConfig?: ApiConfigOptions;
  }
  interface ApiConfigManager {
    identityServerApiConfig: IdentityServerApiConfig;
  }
}

export const CONFIG_FACTORY_TOKEN = new InjectionToken('IdentityServerApiModule Config Factory');

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [LogsApiClient, UsersApiClient, SettingsApiClient],
})
export class IdentityServerApiModule {
  public static forRoot(
    configFactory?: (cfgMgr?: ApiConfigManager) => IdentityServerApiConfig
  ): ModuleWithProviders<IdentityServerApiModule> {
    return {
      ngModule: IdentityServerApiModule,
      providers: [{ provide: CONFIG_FACTORY_TOKEN, useValue: configFactory }],
    };
  }

  constructor(
    cfgMgr: ApiConfigManager,
    moduleRef: NgModuleRef<any>,
    @Optional() @SkipSelf() parentModule: IdentityServerApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('IdentityServerApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    const configFactory: (cfgMgr?: ApiConfigManager) => IdentityServerApiConfig =
      moduleRef.injector.get<any>(CONFIG_FACTORY_TOKEN);
    const config = configFactory
      ? configFactory(cfgMgr)
      : new IdentityServerApiConfig(cfgMgr.withBase(cfgMgr.getRawConfig('identityServerApiConfig')));
    cfgMgr.addApiConfig('identityServerApiConfig', config);
  }
}
